import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import ThankYouPage from 'components/pages/accessories/ThankYouPage';
import Accessories from 'containers/pages/accessories/Accessories';
import CartPage from 'containers/pages/accessories/cart/CartPage';
import AccessoryDetail from 'containers/pages/accessories/detail/AccessoryDetail';

import './AccessoriesPage.sass';

export interface DispatchProps {
    loadData(): void;
}

type CombinedProps = RouteComponentProps<{}> & DispatchProps;

class AccessoriesPage extends React.Component<CombinedProps, {}> {
    public componentWillMount() {
        // this.props.loadData();
    }

    public render() {
        const { match } = this.props;
        return(
            <div className="accessories-page-container">
                <Switch>
                    <Route path={match.url} exact component={Accessories} />
                    <Route path={`${match.url}/cart`} exact component={CartPage} />
                    <Route path={`${match.url}/thankyou`} exact component={ThankYouPage} />
                    <Route path={`${match.url}/:product_id`} exact component={AccessoryDetail} />
                    <Route path={`${match.url}/type/:type`} exact component={Accessories} />
                </Switch>
            </div>
        );
    }
}

const AccessoriesPageStatelessWrapper: React.StatelessComponent<CombinedProps> = (props: CombinedProps) => (<AccessoriesPage {...props} />);

export default AccessoriesPageStatelessWrapper;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/AccessoriesPage.tsx